module.exports = __webpack_public_path__ + "img/Monte_Kope_6.afd25a94.jpg";